
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConfigure as ObiConfigureElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-configure.js';
 
 
 

 
 export const ObiConfigure = createComponent({
   react: React,
   tagName: 'obi-configure',
   elementClass: ObiConfigureElement,
   events: {
     
   }
  });
 
 